// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1lIsm","vLegacy":"SelectSecondary_vLegacy__35vGB","error":"SelectSecondary_error__1IsSi","disabled":"SelectSecondary_disabled__fsHCz"};